// extracted by mini-css-extract-plugin
export default {"treeMenu":"tree_treeMenu__HI4HB","switcherHidden":"tree_switcherHidden__nvFk8"};